import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { AiOutlineSearch } from "react-icons/ai";
import Spinner from '../../../../../components/Spinner'
import { Header, TableWrapper, TableSection, SearchWrapper } from '../../DashBoard/dashBoardStyled'
//table
import { Table } from 'reactstrap';
import CsvDownloader from 'react-csv-downloader';
import { MdKeyboardBackspace } from "react-icons/md";
import Pagination from '@material-ui/lab/Pagination';
import ReferredUsersList from './ReferredUsersList'

function ReferralReport() {
    let history = useHistory();
    let location = useLocation();
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [dataList, setDataList] = useState([]);
    const [finalData, setFinalData] = useState([])
    const [csvData, setCsvData] = useState([])
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [tableSearch, setTableSearch] = useState('')
    const [activePage, setActivePage] = useState('ReferralReport')
    const [headerArr, setHeaderArr] = useState([
        { title: 'Referral Code', },
        { title: 'Username', },
        { title: 'Email', },
        { title: 'Period', },
        { title: 'Referral Count', }
    ])
    const [referredUsersList, setReferredUsersList] = useState([])

    //for csv download
    const [columns, setColumns] = useState([
        { id: 'ReferralCode', displayName: 'Referral Code' },
        { id: 'Username', displayName: 'Username' },
        { id: 'Email', displayName: 'Email' },
        { id: 'Period', displayName: 'Period' },
        { id: 'ReferralCount', displayName: 'Referral Count' }
    ])

    useEffect(() => {
        if (location.state !== null && location.state !== undefined) {

            let tempData = location.state.data
            let filters = location.state.filters

            //set csv data
            csvfunction(tempData)
            // let tempCsvData = tempData.map(val => {
            //     return ({
            //         ReferralCode: val.referralCode,
            //         Username: val.username?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
            //         Email: val.emailId,
            //         Period: `${val.month} ${val.year}`,
            //         ReferralCount: val.referralCount
            //     })
            // })
            // setCsvData(tempCsvData)

            if (tempData !== null) setDataList(tempData)
            //pagination
            let pageData = JSON.parse(JSON.stringify(tempData))
            setFinalData(pageData.splice(page * 10 - 10, 10))
            if (tempData.length % 10 === 0) {
                setPageCount(tempData.length / 10)
            } else {
                setPageCount(Math.trunc(tempData.length / 10) + 1)
            }
        }
    }, []);

    const csvfunction = (getData)=>{
          let tempCsvData = getData.map(val => {
                return ({
                    ReferralCode: val.referralCode,
                    Username: val.username?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                    Email: val.emailId,
                    Period: `${val.month} ${val.year}`,
                    ReferralCount: val.referralCount
                })
            })
            setCsvData(tempCsvData) 
    }

    const handleChange = (event, value) => {
        setPage(value);
        const search = tableSearch
        let dataListtemp = dataList.filter(value => {
            return (
                value.referralCode.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.username.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.emailId.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.referralCount.toString().toLowerCase().includes(search.toLowerCase())
            )
        }
        );
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setFinalData(pageData.splice(value * 10 - 10, 10))
    };

    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value
        let dataListtemp = dataList.filter(value => {
            return (
                value.referralCode.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.username.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.emailId.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.referralCount.toString().toLowerCase().includes(search.toLowerCase())
            )
        }
        );
        csvfunction(dataListtemp)
        setPage(1)
        if (dataListtemp.length % 10 === 0) {
            setPageCount(dataListtemp.length / 10)
        } else {
            setPageCount(Math.trunc(dataListtemp.length / 10) + 1)
        }
        setFinalData(dataListtemp.splice(0, 10))
    }

    const handleCountClick = (e, index) => {
        e.preventDefault()
        setReferredUsersList(finalData[index].listOfUsers)
        setActivePage('ListPage')
    }

    const updateActivePageFunction = (page) => {
        setActivePage(page)
    }

    return (
        <TableWrapper>
            {activePage === 'ReferralReport' ?
                <>
                    {loaderVisible && <Spinner />}
                    <MdKeyboardBackspace style={{ width: '28px', height: '28px', position: 'relative', left: '12px', top: '8px', cursor: 'pointer' }}
                        onClick={() => {
                            history.push({
                                pathname: '/reports',
                                state: { page: 'referral' }
                            })
                        }} />
                    <Header>
                        <h3>Referrals Report </h3>
                        <div style={{ display: 'flex', width: '500px' }}>
                            <SearchWrapper>
                                <input style={{ border: '1px solid #87CDF1', borderRadius: '5px' }} type="text" placeholder='Search' value={tableSearch}
                                    onChange={handleSearchChange} />
                                <AiOutlineSearch />
                            </SearchWrapper>
                            <CsvDownloader
                                filename="Referrals Report"
                                columns={columns}
                                datas={csvData}>
                                <button
                                    style={{ background: '#27911b', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '5px' }}>
                                    Export
                                </button>
                            </CsvDownloader>
                        </div>
                    </Header>
                    <TableSection>
                        <Table responsive>
                            <thead>
                                <tr>
                                    {headerArr.map((items, index) => (
                                        <th key={index}>{items.title}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    finalData.map((items, index) => (
                                        <tr key={index}>
                                            <td>{items.referralCode}</td>
                                            <td>{items.username}</td>
                                            <td>{items.emailId}</td>
                                            <td>{`${items.month}, ${items.year}`}</td>                                    
                                            <td><a style={{ color: '#00b2fe', cursor: 'pointer' }}
                                                onClick={e => handleCountClick(e, index)}
                                            >{items.referralCount}</a></td>
                                        </tr>
                                    ))}
                                {finalData.length === 0 &&
                                    <p style={{ position: 'absolute', width: '100%', textAlign: 'center', marginTop: '30px' }}>No records found</p>
                                }
                            </tbody>
                        </Table>
                    </TableSection>
                    {dataList.length !== 0 && <Pagination count={pageCount}
                        page={page}
                        onChange={handleChange} />}
                </>
                :
                <ReferredUsersList tableData={referredUsersList} updateActivePageFunction={updateActivePageFunction} />
            }


        </TableWrapper>

    )
};

export default ReferralReport;



